import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { GridColDef } from "@mui/x-data-grid";
import TableComponent from "../../components/TableComponent";
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
const RoleDetail = () => {

  const navigate = useNavigate();

  const rows = [
    {
      id: 1,
      name: "Dashboard"
    },
  ];
  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 180,
      field: "name",
      headerName: "Module Name",
      editable: false,
      sortable: false
    },
    {
      flex: 1,
      minWidth: 180,
      field: "view",
      headerName: "View",
      editable: false,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      renderCell: () => {
        return (
          <DoneIcon className="c_success" />
        )
      }
    },
    {
      flex: 1,
      minWidth: 180,
      field: "add",
      headerName: "Add",
      editable: false,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      renderCell: () => {
        return (
          <DoneIcon className="c_success" />
        )
      }
    },
    {
      flex: 1,
      minWidth: 150,
      field: "edit",
      headerName: "Edit",
      editable: false,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      renderCell: () => {
        return (
          <DoneIcon className="c_success" />
        )
      }
    },
    {
      flex: 1,
      minWidth: 100,
      field: "delete",
      headerName: "Delete",
      editable: false,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      renderCell: () => {
        return (
          <CloseIcon className="c_danger" />
        )
      }
    }
  ];
  let hidden = ["fullName"];
      const goBack = () => {
      navigate(-1); 
    };

  return (
    <MainContainer>
      <div className="main_title">
        <h1 className="back_arrow">      <IconButton onClick={() => goBack()}>
                {" "}
                <ArrowBackIcon />{" "}
              </IconButton>Role Detail</h1>
    
      </div>

      <div className="cards view_page table_cards v2">
        <div className="p_20">
        <div className="gap_p">
          <div className="w_33">
            <h6>Role Name</h6>
            <p>Role 1</p>
          </div>
          <div className="w_33">
            <h6>Created Date</h6>
            <p>01 March 2025</p>
          </div>
        </div>
        </div>
        <div className="sorting_table mt_20">
          <TableComponent
            columns={columns?.filter((item) => !hidden.includes(item.field))}
            rows={rows}
          />
        </div>
      </div>
    </MainContainer>
  );
};

export default RoleDetail;
